import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/inter";
import "material-symbols/rounded.css";
import "./index.css";
import Rotas from "./Rotas";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(<Rotas />);
